/**
 * Consultation + invoice endpoints on the Ivipass backend (`/api/ivipass/*`).
 *
 * Replaces the source's module, which pointed at a payment-automation service
 * belonging to an unrelated product and hardcoded a third-party production host.
 */
import { apiUrl, JSON_HEADERS, handleResponse, buildQuery } from './env';

export const ENDPOINTS = {
  SUBMIT_CONSULTATION: '/consultation/submit',
  CONSULTATION_STATS: '/consultation/stats',
  CONSULTATION_LEADS: '/consultation/leads',

  SUBMIT_PAYMENT_REQUEST: '/invoices/payment-request',
  AUTOMATE_PAYMENT: '/invoices/automate-checkout',
  PAYMENT_STATUS: '/invoices/status',
  PAYMENT_REQUESTS: '/invoices/payment-requests',
};

export const getApiUrl = (endpoint) => apiUrl(endpoint);

export const apiService = {
  submitConsultation: async (consultationData) => {
    const response = await fetch(apiUrl(ENDPOINTS.SUBMIT_CONSULTATION), {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(consultationData),
    });
    return handleResponse(response);
  },

  getConsultationStats: async () => {
    const response = await fetch(apiUrl(ENDPOINTS.CONSULTATION_STATS), { headers: JSON_HEADERS });
    return handleResponse(response);
  },

  getConsultationLeads: async (options = {}) => {
    const query = buildQuery(options);
    const response = await fetch(`${apiUrl(ENDPOINTS.CONSULTATION_LEADS)}?${query}`, {
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  submitPaymentRequest: async (userData) => {
    const response = await fetch(apiUrl(ENDPOINTS.SUBMIT_PAYMENT_REQUEST), {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(userData),
    });
    return handleResponse(response);
  },

  automatePayment: async (requestId) => {
    const response = await fetch(apiUrl(ENDPOINTS.AUTOMATE_PAYMENT), {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ requestId }),
    });
    return handleResponse(response);
  },

  getPaymentStatus: async (requestId) => {
    const response = await fetch(apiUrl(`${ENDPOINTS.PAYMENT_STATUS}/${requestId}`), {
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  getPaymentRequests: async (options = {}) => {
    const query = buildQuery(options);
    const response = await fetch(`${apiUrl(ENDPOINTS.PAYMENT_REQUESTS)}?${query}`, {
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  listPaymentRequests: async (status = null, limit = 50) =>
    apiService.getPaymentRequests({ status, limit }),
};

export default { ENDPOINTS, getApiUrl, apiService };
